export default __webpack_public_path__ + "static/media/ProstateCancer3.23859e32.png";